import { ConfirmSchedulePlanResponse } from "../contracts/ConfirmSchedulePlanResponse";
import { PlanResult } from "../models/PlanResult";

export class ConfirmSchedulePlanResponseMapper {
  toPlanResult(response: ConfirmSchedulePlanResponse): PlanResult {
    return {
      items: response.items,
      succeededCount: response.items.filter((item) => !item.error).length,
      failedCount: response.items.filter((item) => item.error).length,
    };
  }
}
